import { equals } from 'ramda';
import React from 'react';
import { Components } from '@fasstech/flexiget';
import classNames from 'classnames';

const StatusComparison = ({ status, tooltip }) => {
  const cls = classNames('h-3 w-3 rounded-full', {
    'bg-flexi-lime': equals('passed', status),
    'bg-flexi-red': equals('failed', status),
    'bg-flexi-warning': equals('waiting', status),
    'bg-gray-600': equals('error', status)
  });

  return (
    <Components.Tooltip title={tooltip}>
      <div className={cls} />
    </Components.Tooltip>
  );
};

export default StatusComparison;
